import { Link } from 'react-router-dom';
import { useLanguage } from '@/contexts/LanguageContext';
import { useLocalePath } from '@/hooks/useLocalePath';
import { MessageCircle, Send } from 'lucide-react';

const Footer = () => {
  const { language, t } = useLanguage();
  const { lp } = useLocalePath();

  const footerLinks = [
    { to: lp('/blog'), label: language === 'fa' ? 'بلاگ' : 'Blog' },
    { to: lp('/about'), label: language === 'fa' ? 'درباره ما' : 'About' },
    { to: lp('/contact'), label: language === 'fa' ? 'تماس' : 'Contact' },
  ];

  return (
    <footer className="py-12 border-t border-border/30">
      <div className="container mx-auto px-4">
        <div className="flex flex-col md:flex-row items-center justify-between gap-8">
          {/* Brand */}
          <div className="space-y-4">
            <Link to={lp('/')} className="flex items-center gap-2 group">
              <span className="text-2xl font-bold text-gradient font-['Orbitron']">Ziqo</span>
            </Link>
            <p className="text-muted-foreground text-sm leading-relaxed max-w-xs">
              {language === 'fa' 
                ? 'اولین و بزرگترین مرجع تخصصی چیت‌های VMP، FiveM و CS2 در ایران با ضمانت عدم بن و پشتیبانی ۲۴ ساعته.'
                : 'The first and largest specialized reference for VMP, FiveM and CS2 cheats with ban-free guarantee and 24/7 support.'}
            </p>
          </div>

          {/* Links */}
          <div className="flex flex-col md:flex-row items-center gap-6">
            <a href={`${lp('/')}#products`} className="text-sm text-muted-foreground hover:text-primary transition-colors">
              {language === 'fa' ? 'محصولات' : 'Products'}
            </a>
            {footerLinks.map((link) => (
              <Link
                key={link.to}
                to={link.to}
                className="text-sm text-muted-foreground hover:text-primary transition-colors"
              >
                {link.label}
              </Link>
            ))}
          </div>

          {/* Social Links */}
          <div className="flex items-center gap-3">
            <a 
              href="https://discord.gg/mashti" 
              target="_blank"
              rel="noopener noreferrer"
              className="p-2.5 rounded-lg bg-muted/50 hover:bg-primary/10 hover:text-primary transition-all group"
              aria-label="Discord"
            >
              <MessageCircle className="w-5 h-5" />
            </a>
            <a 
              href="https://t.me/AliasgharClear" 
              target="_blank"
              rel="noopener noreferrer"
              className="p-2.5 rounded-lg bg-muted/50 hover:bg-primary/10 hover:text-primary transition-all group"
              aria-label="Telegram"
            >
              <Send className="w-5 h-5" />
            </a>
          </div>
        </div>

        {/* Copyright */}
        <div className="mt-8 pt-6 border-t border-border/20 text-center">
          <p className="text-muted-foreground text-sm font-['Vazirmatn']">
            © {new Date().getFullYear()} Ziqo. {t('footer.rights')}
          </p>
          <p className="text-xs text-muted-foreground/60 mt-2">
            Dev By MrLoser(Ali)
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
